<template>
  <b-modal
    id="item-availability-modal"
    :title="`Manage availability for ${itemName}`"
    ok-only
    scrollable
    @shown="fetchBusinessBranches"
  >
    <b-spinner
      v-if="fetchingBranches"
      variant="primary"
    />
    <template v-if="!fetchingBranches">
      <h4>Branches</h4>
      <b-row
        v-for="branch in branchesList"
        :key="branch.id"
      >
        <b-col md="6">
          {{ branch.name.en }}
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            switch
            :checked="isItemActive(branch)"
            @input="updateItemAvailability(branch)"
          />
        </b-col>
        <b-col md="12">
          <hr>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import {
  BSpinner, BFormCheckbox, BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BSpinner,
    BFormCheckbox,
    BRow,
    BCol,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    const itemName = computed(() => props.item?.name?.en)
    const businessId = ctx.root.$route.params.id
    const branchesList = ref([])
    const fetchingBranches = ref(false)
    const itemObj = ref({})
    const fetchItem = async () => {
      // Refetch to update settings (branches)
      const res = await ctx.root.$store.dispatch('business/getOneItem', props.item.id)
      itemObj.value = res.data.data.data
    }
    const fetchBusinessBranches = async () => {
      try {
        branchesList.value = []
        fetchingBranches.value = true
        await fetchItem()
        const result = await ctx.root.$store.dispatch('business/getBusinessBranch', businessId)
        const { data } = result.data.data
        branchesList.value = data
      } finally {
        fetchingBranches.value = false
      }
    }

    const isItemActive = branch => !itemObj.value.settings.branches.includes(branch.id)

    const updateItemAvailability = async branch => {
      await ctx.root.$store.dispatch('business/updateItemAvailability', {
        branchId: branch.id,
        itemId: props.item.id,
      })
    }

    return {
      isItemActive,
      itemName,
      branchesList,
      updateItemAvailability,
      fetchingBranches,
      fetchBusinessBranches,
    }
  },

}
</script>

<style>

</style>
